// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"quick-view-drawer_visually-hidden__uPp1k","qv-drawer":"quick-view-drawer_qv-drawer__iFdDb","qv-drawer__button":"quick-view-drawer_qv-drawer__button__1fnis"};